/**
 * The teacher's assigned regions and the one the page's `?region=` names,
 * shared by the desktop and phone Region schedule pages.
 */
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useViewerRegions } from '../../../hooks/use-viewer-regions';
import type { ScopeHrefFor, ScopeRegion } from '../primitives/scope/scope.types';

import { resolveCurrentRegion, teacherScopeRegions } from './region-schedule-scope';

export interface RegionScheduleScope {
  regions: ScopeRegion[];
  current: ScopeRegion | null;
  hrefFor: ScopeHrefFor;
}

const BASE_PATH = '/me/region-schedule';

const hrefFor: ScopeHrefFor = (region) =>
  region ? `${BASE_PATH}?region=${encodeURIComponent(region.slug)}` : BASE_PATH;

export function useRegionScheduleScope(): RegionScheduleScope {
  const { regionIds, regionNames } = useViewerRegions();
  const regions = useMemo(
    () => teacherScopeRegions(regionIds, regionNames),
    [regionIds, regionNames],
  );
  const [searchParams] = useSearchParams();
  const current = resolveCurrentRegion(regions, searchParams.get('region'));
  return { regions, current, hrefFor };
}
